import { useCallback, useMemo } from 'react';
import { Grid, Typography } from 'antd';
import { WizardContainer } from '../../../components/wizard/Wizard';
import { WizardProvider } from '../../../components/wizard/useWizard';
import { DietaryHabitsAndHealthCareTeamStep } from './DietaryHabitsAndHealthCareTeamStep';
import {
	ViewCareTeamApplicantAnswersProvider,
	useViewCareTeamApplicantAnswers,
} from './useViewCareTeamApplicantAnswers';
import { useTranslation } from 'react-i18next';
import { useInterviewLandingPage } from '../InterviewLandingPage/useInterviewLandingPage';
import { INTERVIEW_LANDING } from '../../../shared/Routes';
import Icon from '../../../components/ui-components/Icon';
import LeftArrow from '../../../assets/images/arrow-left.svg';

const { Text } = Typography;
const { useBreakpoint } = Grid;

export const ViewCareTeamApplicantAnswersWizard = () => {
	const { onSubmitClick } = useViewCareTeamApplicantAnswers();
	const { navigateToPage } = useInterviewLandingPage();
	const { t } = useTranslation();
	const screens = useBreakpoint();
	const isMobile = !screens.sm;
	const currentWizard = 0;
	const wizards = useMemo(
		() => [
			{
				steps: [<DietaryHabitsAndHealthCareTeamStep key={1} />],
				descriptions: [
					{
						title: t('dietaryHabitsAndHealth'),
						description: t('expectedToBeRoleModel') ?? '',
					},
				],
			},
		],
		[t]
	);
	const steps = wizards[currentWizard].steps;

	const customHandlePrevious = useCallback(() => {
		navigateToPage(INTERVIEW_LANDING);
	}, [navigateToPage]);

	const handleEvaluateClick = useCallback(() => {
		navigateToPage(INTERVIEW_LANDING);
	}, [navigateToPage]);

	return (
		<>
			<div
				className={`flex flex-col h-full min-h-0 p-[8px] ${
					!isMobile ? 'w-fit my-0 mx-auto' : 'w-full my-0 mx-auto'
				}`}
			>
				<div className="relative flex justify-between items-center w-full">
					<div
						className="flex font-sans justify-center gap-1 mb-1 items-center cursor-pointer absolute left-0"
						onClick={handleEvaluateClick}
					>
						<Icon src={LeftArrow} width={20} height={20} />
						{!isMobile && (
							<Text className="font-bold text-sm text-primary-blue whitespace-nowrap">
								{t('backToEvaluate')}
							</Text>
						)}
					</div>
					<Text className="flex-grow mt-4 mb-6 font-sans font-bold text-sm text-center text-secondary-black">
						{t('candidateApplication')}
					</Text>
				</div>

				<WizardContainer
					onSubmitClick={onSubmitClick}
					onPreviousClick={customHandlePrevious}
					steps={steps}
					navigateTo={INTERVIEW_LANDING}
				/>
			</div>
		</>
	);
};

export const ViewCareTeamApplicantAnswersWizardContainer = () => {
	return (
		<ViewCareTeamApplicantAnswersProvider>
			<WizardProvider>
				<ViewCareTeamApplicantAnswersWizard />
			</WizardProvider>
		</ViewCareTeamApplicantAnswersProvider>
	);
};
